// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2KzZz","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__WSH5u"};